<div class="flex flex-column row-gap-3">
  <div class="p-fluid field">
    <label class="font-semibold">Para</label>
    <p-chips [formControl]="fieldTo" placeholder="Para..." [addOnBlur]="true" />
    <div *ngIf="fieldTo.invalid && (fieldTo.dirty || fieldTo.touched)">
      <small *ngIf="fieldTo.errors?.['required']" class="text-red-500">El campo es requerido</small>
      <small *ngIf="fieldTo.errors?.['invalidEmails']" class="text-red-500">Correo inválido</small>
    </div>
  </div>
  <div class="p-fluid field">
    <label class="font-semibold">Con copia</label>
    <p-chips [formControl]="fieldCc" placeholder="Con copia a..." [addOnBlur]="true" />
    <div *ngIf="fieldCc.invalid && (fieldCc.dirty || fieldCc.touched)">
      <small *ngIf="fieldCc.errors?.['invalidEmails']" class="text-red-500">Correo inválido</small>
    </div>
  </div>
  <div class="p-fluid field">
    <label class="font-semibold">Con copia oculta</label>
    <p-chips [formControl]="fieldCco" placeholder="Con copia oculta a..." [addOnBlur]="true" />
    <div *ngIf="fieldCco.invalid && (fieldCco.dirty || fieldCco.touched)">
      <small *ngIf="fieldCco.errors?.['invalidEmails']" class="text-red-500">Correo inválido</small>
    </div>
  </div>
  <p-editor [formControl]="message" [style]="{ height: '320px' }" />
  <div *ngIf="message.invalid && (message.dirty || message.touched)">
    <small *ngIf="message.errors?.['required']" class="text-red-500">El campo es requerido</small>
  </div>
  <p-fileUpload [multiple]="true" chooseLabel="Subir archivos" chooseIcon="pi pi-upload" name="files[]"
    maxFileSize="1000000" mode="advanced" [showUploadButton]="false" (onSelect)="onUploadFiles.emit($event)"
    (onClear)="onClearFiles.emit()" (onRemove)="onRemoveFile.emit($event)" />
</div>